export default {
  accountConfig: (state) => {
    return state.accountConfig;
  },

  commodityCategories: (state) => {
    return state.commodityCategories;
  },

  commodityCategoryCode: (state) => {
    return state.commodityCategoryCode;
  },
  commodity: (state) => {
    return state.commodity;
  },

  commodityMaxCode: (state) => {
    return state.commodityMaxCode;
  },

  commodityById: (state) => {
    return state.commodityById;
  },

  dealType: (state) => {
    return state.dealType;
  },
  dealTypeById: (state) => {
    return state.dealTypeById;
  },

  cottage: (state) => {
    return state.cottage;
  },
  cottageById: (state) => {
    return state.cottageById;
  },
  cottageMaxCode: (state) => {
    return state.cottageMaxCode;
  },

  purchase: (state) => {
    return state.purchase;
  },
  purchaseById: (state) => {
    return state.purchaseById;
  },

  order: (state) => {
    return state.order;
  },
  orderById: (state) => {
    return state.orderById;
  },
  orderMaxCode: (state) => {
    return state.orderMaxCode;
  },

  lading: (state) => {
    return state.lading;
  },
  ladingById: (state) => {
    return state.ladingById;
  },

  cottageReport: (state) => {
    return state.cottageReport;
  },
  purchaseReport: (state) => {
    return state.purchaseReport;
  },
  orderReport: (state) => {
    return state.orderReport;
  },
  comprehensiveOrderReport: (state) => {
    return state.comprehensiveOrderReport;
  },
};
